export const formatToDollar = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const isRangeValue = value =>
  value !== null && typeof value === 'object' && 'min' in value && 'max' in value;

// Collapses a {min, max} range value down to a single formatted string using
// formatScalar for each side, matching webapp/src/custom-fields/helpers.ts's
// formatRangeDisplay: a missing side falls back to the other side, and a
// fully empty range formats as null.
export const formatRangeValue = ({ min, max }, formatScalar) => {
  const hasMin = min !== null && min !== undefined;
  const hasMax = max !== null && max !== undefined;
  if (!hasMin && !hasMax) return null;
  if (hasMin && !hasMax) return formatScalar(min);
  if (!hasMin && hasMax) return formatScalar(max);
  return `${formatScalar(min)} - ${formatScalar(max)}`;
};

// True when `value` should be treated as "no value" for formatting purposes.
// Every falsy value counts as missing EXCEPT the number 0, which is a real,
// displayable value (e.g. a $0 TI Allowance floor), not an absent one.
const isMissingValue = value => !value && value !== 0;

export const numberWithCommas = nmb => {
  if (isRangeValue(nmb)) return formatRangeValue(nmb, numberWithCommas);
  if (isMissingValue(nmb)) return null;
  return nmb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatMoney = money => {
  if (isRangeValue(money)) return formatRangeValue(money, formatMoney);
  if (isMissingValue(money)) return null;
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD', // we can omit this to use the system locale

    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(money);
};

export const formatPhoneNumber = raw => {
  const cleaned = (raw || '').replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return null;
};

export const validatePhoneNumber = raw => {
  const cleaned = (raw || '').replace(/\D/g, '');
  return cleaned.length === 10 ? true : 'Phone numbers should be 10 digits.';
};
